import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import promptReducer from './Store/features/prompt/promptSlice';
import chatReducer from './Store/features/chat/chatSlice';
import i18nReducer from './Store/features/i18n/i18nSlice';
import themesReducer from './Store/features/themes/themesSlice';
import settingsReducer from './Store/features/settings/settingsSlice';
import joyrideReducer from './Store/features/joyride/joyrideSlice';
import userSettingsReducer from './Store/features/userSettings/userSettingsSlice';
import errorReducer from './Store/features/error/errorSlice';
import openAIIncidentsReducer from './Store/features/openAIIncidents/openAIIncidentsSlice';
import chatlistReducer from './Store/features/chatlist/chatlistSlice';
import navigationHeaderReducer from './Store/features/navigationHeader/navigationHeaderSlice';
import environmentReducer from './Store/features/environment/environmentSlice';
import messageSourceReducer from './Store/features/messageSource/messageSourceSlice';

export const store = configureStore({
    reducer: {
        prompt: promptReducer,
        chats: chatReducer,
        i18n: i18nReducer,
        themes: themesReducer,
        settings: settingsReducer,
        joyride: joyrideReducer,
        userSettings: userSettingsReducer,
        error: errorReducer,
        openAIIncidents: openAIIncidentsReducer,
        chatlist: chatlistReducer,
        navHeader: navigationHeaderReducer,
        environment: environmentReducer,
        messageSource: messageSourceReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
            immutableCheck: false,
        }),
    devTools: process.env.NODE_ENV !== 'production' && {
        name: 'VARIOS AI',
        trace: true,
        traceLimit: 5,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Typed hooks for RTK store
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
